import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleButton({ label = "Continue with Google" }) {
  return (
    <button type="button" onClick={googleLogin} data-testid="google-login-btn"
      className="w-full flex items-center justify-center gap-3 px-5 py-3 rounded-full border border-slate-200 bg-white hover:bg-slate-50 transition-all font-medium text-slate-700 active:scale-[0.99]">
      <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84z"/><path fill="#EA4335" d="M12 4.75c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.46 14.97.5 12 .5A11 11 0 0 0 2.18 7.05l3.66 2.84C6.71 6.68 9.14 4.75 12 4.75z"/></svg>
      {label}
    </button>
  );
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Brand panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-navy text-white relative overflow-hidden cr-grain">
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-white/10 flex items-center justify-center"><ShieldCheck className="w-5 h-5 text-white" /></div>
            <span className="font-heading font-extrabold text-xl">Crash Ready</span>
          </Link>
          <div>
            <h2 className="font-heading text-4xl font-extrabold leading-tight">Calm, organized, and ready — even on your worst day.</h2>
            <p className="mt-4 text-slate-300 max-w-md">Document evidence, build your timeline, and connect with the right attorney. All in one secure place.</p>
          </div>
          <p className="text-xs text-slate-400">Crash Ready provides documentation tools, not legal advice.</p>
        </div>
      </div>

      {/* Form panel */}
      <div className="flex-1 flex items-center justify-center px-4 py-12 sm:px-8">
        <div className="w-full max-w-md cr-fade-up">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-8 w-8 rounded-xl bg-navy flex items-center justify-center"><ShieldCheck className="w-5 h-5 text-white" /></div>
            <span className="font-heading font-extrabold text-lg text-navy">Crash Ready</span>
          </Link>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-navy">{title}</h1>
          {subtitle && <p className="mt-2 text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export const inputCls = "w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-base focus:ring-2 focus:ring-cobalt/20 focus:border-cobalt transition-all outline-none";
export const primaryBtn = "w-full px-6 py-3.5 rounded-full bg-cobalt text-white font-medium hover:bg-cobalt-hover transition-all shadow-md hover:shadow-lg active:scale-[0.99] disabled:opacity-60";
